// SEO Location Data - HQ.D Bartending Services across India
// Each location has unique content for SEO ranking

export const LOCATIONS = [
  {
    id: 'delhi-ncr',
    slug: 'delhi-ncr',
    city: 'Delhi NCR',
    state: 'Delhi',
    heroTitle: 'Premium Bar Services in Delhi NCR',
    heroSubtitle: 'Luxury cocktail & mocktail bar setups for weddings and events across Delhi, Gurgaon, Noida & Faridabad.',
    metaTitle: 'HQ.D | Best Wedding Bar Services in Delhi NCR | Cocktail & Mocktail Bar Setup',
    metaDescription: 'Looking for premium bar services in Delhi NCR? HQ.D provides luxury cocktail & mocktail bar setups for weddings, corporate events & private parties in Delhi, Gurgaon, Noida. 500+ events served.',
    keywords: 'bar service delhi, wedding bar setup delhi ncr, cocktail bar gurgaon, mocktail bar noida, bartender for wedding delhi, bar agency delhi ncr, molecular mixology delhi',
    intro: 'Delhi NCR is the heart of India\'s most lavish celebrations. From the grand farmhouses of Chattarpur to the five-star ballrooms of Gurgaon, HQ.D has been the preferred bar partner for over 300 events across the National Capital Region.',
    whyUs: [
      'Based in Delhi NCR with instant availability for last-minute events',
      'Served 300+ weddings across Delhi, Gurgaon, Noida, and Faridabad',
      'Trusted by top wedding planners including The Wedding Design Company, FNP Weddings, and Rani Pink',
      'Premium inventory of bar setups, glassware, and molecular equipment ready to deploy',
      'Professional bartending team of 50+ trained mixologists',
      'Same-day consultation available for NCR clients'
    ],
    popularVenues: [
      'The Leela Palace, New Delhi',
      'ITC Grand Bharat, Gurgaon',
      'Taj Palace, New Delhi',
      'The Oberoi, Gurgaon',
      'Farmhouses in Chattarpur & MG Road',
      'Jaypee Greens Golf Resort, Greater Noida'
    ],
    popularEvents: ['Destination Wedding', 'Sangeet Night', 'Corporate Gala', 'Engagement Ceremony', 'Pool Party', 'Reception'],
    testimonial: {
      quote: 'HQ.D made our Delhi wedding absolutely unforgettable. The molecular cocktails at our sangeet were the highlight of the evening!',
      name: 'Priya & Rahul Sharma',
      event: 'Wedding at The Leela Palace'
    },
    nearbyAreas: ['Delhi', 'Gurgaon', 'Noida', 'Faridabad', 'Greater Noida', 'Ghaziabad', 'Manesar'],
    geo: { lat: '28.6139', lng: '77.2090' },
    image: 'https://images.unsplash.com/photo-1574096079513-d8259312b785?w=800&q=80'
  },
  {
    id: 'jaipur',
    slug: 'jaipur',
    city: 'Jaipur',
    state: 'Rajasthan',
    heroTitle: 'Royal Bar Services in Jaipur',
    heroSubtitle: 'Premium cocktail & mocktail bars for royal Rajasthani weddings and destination celebrations in the Pink City.',
    metaTitle: 'HQ.D | Best Bar Services in Jaipur | Wedding Cocktail Bar Setup Rajasthan',
    metaDescription: 'Premium bar services in Jaipur for royal weddings & destination events. HQ.D offers luxury cocktail & mocktail bar setups at heritage venues across Jaipur. Book now!',
    keywords: 'bar service jaipur, wedding bar jaipur, cocktail bar rajasthan, destination wedding bar jaipur, bartender jaipur, bar agency jaipur, mocktail bar jaipur',
    intro: 'Jaipur — the Pink City — is India\'s most sought-after destination wedding location. With its majestic forts, heritage havelis, and royal palaces, every celebration here demands an equally regal bar experience. HQ.D brings luxury bartending that matches Jaipur\'s grandeur.',
    whyUs: [
      'Extensive experience with 80+ destination weddings in Jaipur',
      'Partnerships with all major heritage venues and palace hotels',
      'Travel-ready team with complete setup — nothing sourced locally',
      'Royal-themed bar designs that complement Rajasthani aesthetics',
      'Specialized desert-climate drink menus with refreshing cocktails',
      'Coordination with local event planners and caterers'
    ],
    popularVenues: [
      'Rambagh Palace',
      'Jai Mahal Palace',
      'Fairmont Jaipur',
      'The Oberoi Rajvilas',
      'Samode Palace',
      'Chomu Palace'
    ],
    popularEvents: ['Royal Destination Wedding', 'Palace Celebration', 'Sangeet Under The Stars', 'Mehendi Garden Party', 'Heritage Reception'],
    testimonial: {
      quote: 'Our destination wedding at Samode Palace was magical, and HQ.D\'s bar setup was the crown jewel. Guests are still talking about those smoke bubble cocktails!',
      name: 'Vikram & Neha Kapoor',
      event: 'Destination Wedding at Samode Palace'
    },
    nearbyAreas: ['Jaipur', 'Ajmer', 'Pushkar', 'Neemrana', 'Mandawa'],
    geo: { lat: '26.9124', lng: '75.7873' },
    image: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=800&q=80'
  },
  {
    id: 'udaipur',
    slug: 'udaipur',
    city: 'Udaipur',
    state: 'Rajasthan',
    heroTitle: 'Luxury Bar Services in Udaipur',
    heroSubtitle: 'Exquisite cocktail experiences for lakeside weddings and palatial celebrations in the City of Lakes.',
    metaTitle: 'HQ.D | Luxury Bar Services Udaipur | Wedding Cocktail Bar Lake City',
    metaDescription: 'Premium bar services in Udaipur for lakeside weddings & luxury events. HQ.D provides world-class cocktail & mocktail bar setups at Udaipur\'s finest venues. Get a quote!',
    keywords: 'bar service udaipur, wedding bar udaipur, cocktail bar lake city, destination wedding bartender udaipur, luxury bar udaipur, bar agency udaipur',
    intro: 'Udaipur, the Venice of the East, is where fairy-tale weddings come to life. Against the backdrop of shimmering lakes and ivory palaces, HQ.D creates bar experiences that are as breathtaking as the sunsets over Lake Pichola. We\'ve served at the most prestigious venues in Udaipur.',
    whyUs: [
      'Served 50+ ultra-luxury destination weddings in Udaipur',
      'Expert logistics team for remote palace and lakeside setups',
      'Bespoke bar designs complementing Udaipur\'s romantic aesthetic',
      'Experience with multi-day wedding celebrations (3-5 day events)',
      'Full molecular mixology setup transported from Delhi',
      'Coordination with top Udaipur wedding planners'
    ],
    popularVenues: [
      'The Oberoi Udaivilas',
      'Taj Lake Palace',
      'The Leela Palace Udaipur',
      'Jagmandir Island Palace',
      'RAAS Devigarh',
      'Chunda Palace'
    ],
    popularEvents: ['Lakeside Wedding', 'Palace Reception', 'Sunset Cocktail Party', 'Poolside Celebration', 'Royal Mehendi'],
    testimonial: {
      quote: 'HQ.D traveled all the way to Udaipur for our wedding at Jagmandir and set up the most incredible bar we\'ve ever seen. Pure magic!',
      name: 'Simran & Arjun Malhotra',
      event: 'Destination Wedding at Jagmandir'
    },
    nearbyAreas: ['Udaipur', 'Mount Abu', 'Kumbhalgarh', 'Chittorgarh'],
    geo: { lat: '24.5854', lng: '73.7125' },
    image: 'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=800&q=80'
  },
  {
    id: 'agra',
    slug: 'agra',
    city: 'Agra',
    state: 'Uttar Pradesh',
    heroTitle: 'Premium Bar Services in Agra',
    heroSubtitle: 'Elegant cocktail & mocktail bars for weddings and celebrations in the city of the Taj Mahal.',
    metaTitle: 'HQ.D | Best Bar Services in Agra | Wedding Cocktail Bar Setup Near Taj Mahal',
    metaDescription: 'Premium bar services in Agra for weddings & events near the Taj Mahal. HQ.D offers luxury cocktail & mocktail bar setups with molecular mixology. 500+ events served across India.',
    keywords: 'bar service agra, wedding bar agra, cocktail bar agra, bartender agra, bar agency agra, mocktail bar agra, wedding near taj mahal bar',
    intro: 'Agra — home to the symbol of eternal love, the Taj Mahal — is a city where celebrations carry the romance of centuries. HQ.D brings premium bartending services that match the grandeur of your Agra celebration, whether it\'s at a heritage hotel overlooking the Taj or a luxurious farmhouse.',
    whyUs: [
      'Just 3 hours from our Delhi NCR base — rapid deployment',
      'Experience with heritage venue setups in Agra',
      'Taj-inspired signature cocktails and thematic bar designs',
      'Full service including setup, bartending, and cleanup',
      'Molecular mixology that adds a wow factor to every event',
      'Flexible packages for all event sizes'
    ],
    popularVenues: [
      'The Oberoi Amarvilas',
      'ITC Mughal',
      'Taj Hotel & Convention Centre',
      'Crystal Sarovar Premiere',
      'Jaypee Palace Hotel',
      'Heritage farmhouses in Agra'
    ],
    popularEvents: ['Wedding Reception', 'Engagement Ceremony', 'Corporate Retreat', 'Sangeet Night', 'Anniversary Celebration'],
    testimonial: {
      quote: 'We wanted our Agra wedding to be special, and HQ.D delivered beyond expectations. The Taj-inspired cocktail menu was a beautiful touch.',
      name: 'Riya & Karan Agarwal',
      event: 'Wedding at The Oberoi Amarvilas'
    },
    nearbyAreas: ['Agra', 'Mathura', 'Vrindavan', 'Fatehpur Sikri'],
    geo: { lat: '27.1767', lng: '78.0081' },
    image: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=800&q=80'
  },
  {
    id: 'jim-corbett',
    slug: 'jim-corbett',
    city: 'Jim Corbett',
    state: 'Uttarakhand',
    heroTitle: 'Wilderness Bar Services in Jim Corbett',
    heroSubtitle: 'Luxury bartending amidst nature — perfect for destination weddings and resort celebrations in Jim Corbett National Park.',
    metaTitle: 'HQ.D | Bar Services Jim Corbett | Destination Wedding Bar Setup Uttarakhand',
    metaDescription: 'Premium bar services in Jim Corbett for destination weddings & resort events. HQ.D brings luxury cocktail bars to the wilderness. Molecular mixology in nature\'s lap.',
    keywords: 'bar service jim corbett, wedding bar jim corbett, cocktail bar uttarakhand, destination wedding bartender jim corbett, resort bar service, bar agency jim corbett',
    intro: 'Jim Corbett National Park offers a unique blend of luxury and wilderness that makes it one of India\'s most exciting destination wedding locations. HQ.D brings world-class bar experiences to this stunning setting, creating cocktail moments surrounded by nature\'s beauty.',
    whyUs: [
      '5-hour drive from Delhi — our team arrives fully equipped',
      'Experience with resort and outdoor wilderness setups',
      'Nature-inspired cocktail menus with fresh botanicals',
      'Compact, travel-ready bar equipment for remote locations',
      'Coordination with Jim Corbett\'s top resorts and planners',
      'Stunning outdoor bar setups amidst natural beauty'
    ],
    popularVenues: [
      'The Solluna Resort',
      'Jim\'s Jungle Retreat',
      'Aahana Resort',
      'Namah by Jim Corbett',
      'The Riverview Retreat',
      'Corbett Leela Vilas'
    ],
    popularEvents: ['Destination Wedding', 'Resort Celebration', 'Jungle Theme Party', 'Corporate Offsite', 'Anniversary Getaway'],
    testimonial: {
      quote: 'Having HQ.D at our Jim Corbett wedding was the best decision. Their outdoor bar setup surrounded by the forest was absolutely magical.',
      name: 'Ankit & Meera Thakur',
      event: 'Destination Wedding at Solluna Resort'
    },
    nearbyAreas: ['Jim Corbett', 'Ramnagar', 'Nainital', 'Bhimtal'],
    geo: { lat: '29.5300', lng: '78.7700' },
    image: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=800&q=80'
  },
  {
    id: 'goa',
    slug: 'goa',
    city: 'Goa',
    state: 'Goa',
    heroTitle: 'Beach Bar Services in Goa',
    heroSubtitle: 'Tropical cocktail & mocktail bars for beach weddings, villa celebrations, and sunset parties in Goa.',
    metaTitle: 'HQ.D | Best Bar Services in Goa | Beach Wedding Cocktail Bar Setup',
    metaDescription: 'Premium beach bar services in Goa for weddings & events. HQ.D offers luxury cocktail & mocktail setups at Goa\'s finest beach venues and villas. Get a quote!',
    keywords: 'bar service goa, beach wedding bar goa, cocktail bar goa, destination wedding bartender goa, beach party bar, bar agency goa, mocktail bar goa',
    intro: 'Goa is synonymous with sun, sand, and celebrations. Whether it\'s a bohemian beach wedding in South Goa or a glamorous villa party in North Goa, HQ.D brings premium bar experiences that perfectly complement the tropical vibe. Our beach-ready setups are designed for Goa\'s unique charm.',
    whyUs: [
      'Beach-ready bar equipment designed for outdoor tropical settings',
      'Tropical cocktail menus with fresh Goan ingredients',
      'Experience with 40+ beach and villa weddings in Goa',
      'Coordination with top Goa wedding planners and venues',
      'Sunset cocktail experiences with molecular mixology',
      'Full team flies in with all equipment from Delhi'
    ],
    popularVenues: [
      'W Goa',
      'Taj Fort Aguada Resort',
      'Grand Hyatt Goa',
      'Alila Diwa Goa',
      'Park Hyatt Goa',
      'Private villas in Assagao & Anjuna'
    ],
    popularEvents: ['Beach Wedding', 'Sunset Cocktail Party', 'Villa Celebration', 'Pool Party', 'New Year\'s Eve Bash'],
    testimonial: {
      quote: 'Our beach wedding in Goa was everything we dreamed of, and HQ.D\'s tropical cocktail bar was the centerpiece. The coconut shell presentations were pure genius!',
      name: 'Nisha & Dev Patel',
      event: 'Beach Wedding at W Goa'
    },
    nearbyAreas: ['North Goa', 'South Goa', 'Panjim', 'Calangute', 'Anjuna', 'Candolim'],
    geo: { lat: '15.2993', lng: '74.1240' },
    image: 'https://images.unsplash.com/photo-1560963689-b5682b6440f8?w=800&q=80'
  },
  {
    id: 'mumbai',
    slug: 'mumbai',
    city: 'Mumbai',
    state: 'Maharashtra',
    heroTitle: 'Premium Bar Services in Mumbai',
    heroSubtitle: 'Sophisticated cocktail & mocktail bars for high-society weddings, corporate events, and Bollywood parties in Mumbai.',
    metaTitle: 'HQ.D | Best Bar Services in Mumbai | Wedding & Corporate Cocktail Bar Setup',
    metaDescription: 'Premium bar services in Mumbai for weddings, corporate events & private parties. HQ.D offers luxury cocktail & mocktail setups with molecular mixology. Get a quote!',
    keywords: 'bar service mumbai, wedding bar mumbai, cocktail bar mumbai, corporate event bar mumbai, bartender mumbai, bar agency mumbai, molecular mixology mumbai',
    intro: 'Mumbai — the city of dreams — hosts some of India\'s most glamorous celebrations. From South Mumbai\'s iconic sea-facing venues to Bandra\'s chic rooftops, HQ.D delivers world-class bar experiences for the city\'s most discerning hosts.',
    whyUs: [
      'Served 70+ premium events in Mumbai',
      'Quick deployment via air — all equipment travels with us',
      'Understanding of Mumbai\'s premium venue requirements',
      'Corporate expertise for product launches and client events',
      'High-volume service capability for Mumbai\'s grand celebrations',
      'Bollywood-inspired signature cocktails and thematic menus'
    ],
    popularVenues: [
      'The St. Regis Mumbai',
      'Taj Lands End',
      'Four Seasons Hotel Mumbai',
      'JW Marriott Mumbai Sahar',
      'The Dome at NSCI',
      'Private bungalows in Juhu & Alibaug'
    ],
    popularEvents: ['Grand Wedding', 'Corporate Gala', 'Product Launch', 'Celebrity Party', 'Rooftop Celebration'],
    testimonial: {
      quote: 'HQ.D handled our corporate gala at St. Regis flawlessly. 400 guests, premium service, and the branded cocktails were a massive hit.',
      name: 'Ananya Mehta',
      event: 'Corporate Event at The St. Regis'
    },
    nearbyAreas: ['Mumbai', 'Navi Mumbai', 'Thane', 'Alibaug', 'Lonavala'],
    geo: { lat: '19.0760', lng: '72.8777' },
    image: 'https://images.unsplash.com/photo-1566417713940-fe7c737a9ef2?w=800&q=80'
  },
  {
    id: 'bangalore',
    slug: 'bangalore',
    city: 'Bangalore',
    state: 'Karnataka',
    heroTitle: 'Premium Bar Services in Bangalore',
    heroSubtitle: 'Modern cocktail & mocktail bars for tech-city weddings, startup parties, and sophisticated celebrations in Bangalore.',
    metaTitle: 'HQ.D | Best Bar Services in Bangalore | Wedding Cocktail Bar Setup Karnataka',
    metaDescription: 'Premium bar services in Bangalore for weddings & corporate events. HQ.D offers luxury cocktail & mocktail bar setups with molecular mixology. Book now!',
    keywords: 'bar service bangalore, wedding bar bangalore, cocktail bar bangalore, corporate event bar bengaluru, bartender bangalore, bar agency bangalore',
    intro: 'Bangalore — India\'s tech capital — is a city that appreciates innovation and sophistication. HQ.D brings molecular mixology and premium bar experiences to Bangalore\'s vibrant celebration scene, from lush palace hotels to modern rooftop venues.',
    whyUs: [
      'Regular service to Bangalore with growing client base',
      'Modern, innovative bar concepts perfect for Bangalore\'s tech-savvy crowd',
      'Experience with outdoor garden venue setups',
      'Corporate event expertise for tech companies and startups',
      'Full molecular mixology experience transported from Delhi',
      'Coordination with Bangalore\'s top event management companies'
    ],
    popularVenues: [
      'ITC Gardenia',
      'The Leela Palace Bangalore',
      'Taj West End',
      'JW Marriott Hotel Bengaluru',
      'Palace Grounds',
      'Vineyard venues on Nandi Hills'
    ],
    popularEvents: ['Tech Wedding', 'Corporate Offsite', 'Startup Launch Party', 'Garden Reception', 'Rooftop Celebration'],
    testimonial: {
      quote: 'We brought HQ.D all the way from Delhi for our Bangalore wedding and it was worth every penny. Their molecular cocktails blew everyone\'s minds!',
      name: 'Sneha & Arun Kumar',
      event: 'Wedding at ITC Gardenia'
    },
    nearbyAreas: ['Bangalore', 'Mysore', 'Coorg', 'Nandi Hills'],
    geo: { lat: '12.9716', lng: '77.5946' },
    image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=800&q=80'
  },
  {
    id: 'lucknow',
    slug: 'lucknow',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    heroTitle: 'Nawabi Bar Services in Lucknow',
    heroSubtitle: 'Premium cocktail & mocktail bars for royal celebrations and grand weddings in the City of Nawabs.',
    metaTitle: 'HQ.D | Best Bar Services in Lucknow | Wedding Cocktail Bar Setup UP',
    metaDescription: 'Premium bar services in Lucknow for weddings & events. HQ.D offers luxury cocktail & mocktail bar setups with Nawabi-inspired menus. Book your event!',
    keywords: 'bar service lucknow, wedding bar lucknow, cocktail bar lucknow, bartender lucknow, bar agency lucknow, wedding bartender lucknow',
    intro: 'Lucknow, the City of Nawabs, is known for its refined taste and grand celebrations. HQ.D brings premium bar experiences that honour Lucknow\'s tradition of sophistication while adding a modern molecular twist to every celebration.',
    whyUs: [
      'Short drive from Delhi — our full team and equipment travel',
      'Nawabi-inspired signature cocktails and thematic menus',
      'Experience with Lucknow\'s lavish wedding traditions',
      'Premium service matching Lucknow\'s standard of hospitality',
      'Molecular mixology adding modern flair to traditional celebrations',
      'Flexible packages for all budget ranges'
    ],
    popularVenues: [
      'Taj Mahal Lucknow',
      'Vivanta by Taj',
      'Hyatt Regency Lucknow',
      'The Piccadily',
      'Renaissance Lucknow Hotel',
      'Premium farmhouses and banquet halls'
    ],
    popularEvents: ['Grand Wedding', 'Engagement Ceremony', 'Nawabi Celebration', 'Corporate Event', 'Anniversary'],
    testimonial: {
      quote: 'HQ.D brought Delhi-level sophistication to our Lucknow wedding. The Nawabi-themed cocktails were a beautiful tribute to our heritage.',
      name: 'Fatima & Ayaan Khan',
      event: 'Wedding at Taj Mahal Lucknow'
    },
    nearbyAreas: ['Lucknow', 'Kanpur', 'Allahabad', 'Varanasi'],
    geo: { lat: '26.8467', lng: '80.9462' },
    image: 'https://images.unsplash.com/photo-1572116469696-31de0f17cc34?w=800&q=80'
  },
  {
    id: 'chandigarh',
    slug: 'chandigarh',
    city: 'Chandigarh',
    state: 'Punjab/Haryana',
    heroTitle: 'Premium Bar Services in Chandigarh',
    heroSubtitle: 'High-energy cocktail & mocktail bars for Punjabi weddings and celebrations in the City Beautiful.',
    metaTitle: 'HQ.D | Best Bar Services in Chandigarh | Wedding Cocktail Bar Punjab',
    metaDescription: 'Premium bar services in Chandigarh for weddings & events. HQ.D offers luxury cocktail & mocktail setups for grand Punjabi celebrations. Get a quote today!',
    keywords: 'bar service chandigarh, wedding bar chandigarh, cocktail bar chandigarh, punjabi wedding bartender, bar agency chandigarh, mohali bar service',
    intro: 'Chandigarh — the City Beautiful — is home to India\'s most vibrant and energetic celebrations. Punjabi weddings are legendary for their scale and enthusiasm, and HQ.D brings bar experiences that match this incredible energy.',
    whyUs: [
      '4-hour drive from Delhi — frequent service to Chandigarh',
      'High-energy bar setups matching Punjabi celebration vibes',
      'Experience with large-scale events (300-800 guests)',
      'Bhangra-themed cocktails and high-volume service',
      'Full team and equipment from Delhi with backup supplies',
      'Coordination with Punjab\'s top wedding planners'
    ],
    popularVenues: [
      'The Oberoi Sukhvilas',
      'JW Marriott Chandigarh',
      'Taj Chandigarh',
      'Hyatt Regency Chandigarh',
      'The Lalit Chandigarh',
      'Farm venues in Mohali & Zirakpur'
    ],
    popularEvents: ['Punjabi Wedding', 'Sangeet Night', 'Engagement Party', 'Corporate Event', 'Cocktail Reception'],
    testimonial: {
      quote: 'Our Chandigarh wedding had 600 guests and HQ.D handled the bar like pros! The sangeet cocktail bar was absolutely incredible.',
      name: 'Harpreet & Jasleen Gill',
      event: 'Wedding at The Oberoi Sukhvilas'
    },
    nearbyAreas: ['Chandigarh', 'Mohali', 'Panchkula', 'Zirakpur', 'Kasauli'],
    geo: { lat: '30.7333', lng: '76.7794' },
    image: 'https://images.unsplash.com/photo-1536935338788-846bb9981813?w=800&q=80'
  },
  {
    id: 'jodhpur',
    slug: 'jodhpur',
    city: 'Jodhpur',
    state: 'Rajasthan',
    heroTitle: 'Heritage Bar Services in Jodhpur',
    heroSubtitle: 'Majestic cocktail experiences for fort weddings and heritage celebrations in the Blue City.',
    metaTitle: 'HQ.D | Bar Services Jodhpur | Heritage Wedding Cocktail Bar Rajasthan',
    metaDescription: 'Premium bar services in Jodhpur for heritage fort weddings & destination events. HQ.D brings luxury cocktail bars to Rajasthan\'s most majestic venues. Book now!',
    keywords: 'bar service jodhpur, wedding bar jodhpur, fort wedding bar, destination wedding bartender jodhpur, heritage bar setup, bar agency jodhpur',
    intro: 'Jodhpur, the Blue City, offers a dramatic and majestic backdrop for celebrations. From the imposing Mehrangarh Fort to the serene Umaid Bhawan Palace, HQ.D creates bar experiences worthy of these extraordinary settings.',
    whyUs: [
      'Experience with heritage fort and palace venue setups',
      'Complete logistics for remote Rajasthani locations',
      'Desert-inspired cocktail menus with local botanicals',
      'Bar designs that complement fort and heritage architecture',
      'Multi-day event expertise for destination wedding itineraries',
      'Trusted by premium destination wedding planners'
    ],
    popularVenues: [
      'Umaid Bhawan Palace',
      'RAAS Jodhpur',
      'Welcomhotel by ITC Jodhpur',
      'Mehrangarh Fort (private events)',
      'Taj Hari Mahal',
      'The Ajit Bhawan'
    ],
    popularEvents: ['Fort Wedding', 'Palace Reception', 'Desert Celebration', 'Heritage Mehendi', 'Royal Sangeet'],
    testimonial: {
      quote: 'A bar setup at RAAS Jodhpur with the fort in the background — HQ.D made our dream wedding a reality.',
      name: 'Aditi & Rohan Singh',
      event: 'Destination Wedding at RAAS Jodhpur'
    },
    nearbyAreas: ['Jodhpur', 'Jaisalmer', 'Ranakpur', 'Mount Abu'],
    geo: { lat: '26.2389', lng: '73.0243' },
    image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80'
  },
  {
    id: 'rishikesh',
    slug: 'rishikesh-mussoorie',
    city: 'Rishikesh & Mussoorie',
    state: 'Uttarakhand',
    heroTitle: 'Mountain Bar Services in Rishikesh & Mussoorie',
    heroSubtitle: 'Premium cocktail bars for hill-station weddings and riverside celebrations in Uttarakhand.',
    metaTitle: 'HQ.D | Bar Services Rishikesh Mussoorie | Mountain Wedding Cocktail Bar',
    metaDescription: 'Premium bar services in Rishikesh & Mussoorie for mountain weddings & resort events. HQ.D brings luxury cocktail bars to Uttarakhand\'s finest hill stations.',
    keywords: 'bar service rishikesh, wedding bar mussoorie, cocktail bar uttarakhand, mountain wedding bartender, resort bar service, bar agency rishikesh',
    intro: 'The Uttarakhand hills — from the spiritual banks of Rishikesh to the colonial charm of Mussoorie — offer unforgettable wedding settings. HQ.D brings premium bar services to these mountain destinations, creating magical cocktail experiences with valley views.',
    whyUs: [
      'Regular service to Uttarakhand hill stations from Delhi',
      'Mountain-ready equipment and logistics expertise',
      'Fresh botanical cocktails inspired by Himalayan herbs',
      'Experience with riverside and terrace venue setups',
      'Climate-appropriate drink menus for mountain weather',
      'Coordination with Uttarakhand resort event teams'
    ],
    popularVenues: [
      'JW Marriott Mussoorie',
      'Aloha on the Ganges, Rishikesh',
      'Ananda in the Himalayas',
      'The Claridges Nabha Residence',
      'Atali Ganga Resort',
      'Vana Retreat'
    ],
    popularEvents: ['Mountain Wedding', 'Riverside Celebration', 'Resort Party', 'Corporate Retreat', 'Wellness Event'],
    testimonial: {
      quote: 'HQ.D set up the most gorgeous bar overlooking the Ganges at our Rishikesh wedding. The herbal cocktails were inspired!',
      name: 'Pooja & Nikhil Verma',
      event: 'Wedding at Aloha on the Ganges'
    },
    nearbyAreas: ['Rishikesh', 'Mussoorie', 'Dehradun', 'Haridwar'],
    geo: { lat: '30.0869', lng: '78.2676' },
    image: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=800&q=80'
  }
];

// Get location by slug
export function getLocationBySlug(slug) {
  return LOCATIONS.find(loc => loc.slug === slug);
}

// Get all location slugs for routing
export function getAllLocationSlugs() {
  return LOCATIONS.map(loc => loc.slug);
}

// Group locations by state for footer
export function getLocationsByState() {
  const grouped = {};
  LOCATIONS.forEach(loc => {
    if (!grouped[loc.state]) grouped[loc.state] = [];
    grouped[loc.state].push(loc);
  });
  return grouped;
}
